import { composeClassNames, ifDefined } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import Translate from "src/components/Translate";
import constants from "src/constants";
import { sPaid } from "src/styles/sPaid.module.scss";
import { sVideoLabel } from "src/styles/sVideoLabel.module.scss";
import { VariantPaid } from "src/types/VariantPaid";
import { VariantSize } from "src/types/VariantSize";

type Props = {
  paid?: boolean | null | undefined;
  isPaid?: boolean | null | undefined;
  subscription?: boolean | null | undefined;
  showPaid?: boolean | null | undefined;
  size?: VariantSize | null | undefined;
  className?: (string | string) | null | undefined;
  style?: CSSProperties | null | undefined;
};

function Paid({
  paid,
  isPaid,
  subscription,
  showPaid,
  size,
  className,
  style,
}: Props) {
  const type: VariantPaid = isPaid
    ? "is-paid"
    : paid
    ? subscription
      ? "paid"
      : "premium"
    : "sample";

  return constants.Show.salePaidContent &&
    type &&
    type !== "paid" &&
    !showPaid ? (
    <div
      style={style}
      className={composeClassNames([
        sVideoLabel,
        "light",
        sPaid,
        className,
        type,
        size,
      ])}
    >
      {ifDefined(
        type,
        (value) =>
          (function () {
            switch (value) {
              case "paid":
                return <Translate tKey={`Paid content`} />;
              case "is-paid":
                return <Translate tKey={`Is paid`} />;
              case "premium":
                return <Translate tKey={`Premium`} />;
              default:
                return <Translate tKey={`Sample`} />;
            }
          })(),
        () => null
      )}
    </div>
  ) : null;
}

export default Paid;
